import { render, staticRenderFns } from "./RandomBox.vue?vue&type=template&id=77f179d2&scoped=true&"
import script from "./RandomBox.vue?vue&type=script&lang=js&"
export * from "./RandomBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f179d2",
  null
  
)

export default component.exports